import React from 'react';
import styles from './Carousel.module.css';
import { NavLink } from 'react-router-dom';


const CategoriesCard = ({ categorie, handleArrows }) => {
    return (
        <div className={styles.card} style={{backgroundImage: `url(${categorie.src})`}}>
            <div className={styles.filter}>
                <img onClick={() => handleArrows(-1)} src='/BreadCrumb/forwardIcon.png' alt='' className={styles.arrows} />
                <img onClick={() => handleArrows(1)} src='/BreadCrumb/forwardIcon.png' alt='' className={styles.arrows} />
                <NavLink className={styles.data} to={categorie.to}>
                    <h1 className={styles.subtitle}>{categorie.title}</h1>
                    <p className={styles.paragraph}>{categorie.description}</p>
                </NavLink>
            </div>
        </div>
    );
};

export default CategoriesCard;